import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MachineSalesForm from "../components/contact/MachineSalesForm";
import PrintJobForm from "../components/contact/PrintJobForm";
import GeneralContactForm from "../components/contact/GeneralContactForm";
import ReferralForm from "../components/contact/ReferralForm";

const Contact = () => {
  const location = useLocation();
  const [selectedForm, setSelectedForm] = useState("General Inquiry");

  // Parse query parameter for form type
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get("type");
    if (
      type === "Machine Inquiry" ||
      type === "Print Job" ||
      type === "General Inquiry" ||
      type === "Referral"
    ) {
      setSelectedForm(type);
    }
  }, [location]);

  const renderForm = () => {
    switch (selectedForm) {
      case "Machine Inquiry":
        return <MachineSalesForm />;
      case "Print Job":
        return <PrintJobForm />;
      // case "Referral":
      //   return <ReferralForm />;
      default:
        return <MachineSalesForm />;
    }
  };

  return (
    <div className="container mx-auto px-6 py-12 sm:px-8 md:px-12 lg:px-16 xl:px-60">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Contact Information Section */}
        <div className="bg-primary text-white p-8 rounded-lg shadow-lg flex flex-col justify-between">
          <div className="text-center mb-8">
            <div className="bg-white p-6 rounded-lg shadow-md inline-block">
              <img
                src="https://surfacepix-media.s3.us-west-2.amazonaws.com/global/Asset_6.png"
                alt="SurfacePix Logo"
                className="w-full h-auto object-contain max-w-md mx-auto"
              />
            </div>
          </div>
          <div className="text-center mb-8">
            <h3 className="font-bold text-lg">Silicon Slopes, USA</h3>
            <p className="mt-2">1543 W 1430 N STE 200, Orem, UT 84057</p>
            <p className="mt-2">+1 385.625.9812</p>
            <p className="mt-2">info@surfacepix.com</p>
            <p className="mt-2">Mon – Sat: 09:00 AM – 05:00 PM</p>
            <p className="mt-2 font-semibold">Showroom: By Appointment Only</p>
          </div>
          <hr className="border-gray-300 my-6" />
          <div className="text-center">
            <h3 className="font-bold text-lg">Manufacturer, Germany</h3>
            <p className="mt-2">Werkstrasse 15, 57537 Wissen</p>
            <p className="mt-2">+49 2742.966800</p>
            <p className="mt-2">info@wallpen.com</p>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="bg-gray-100 p-8 rounded-lg shadow-lg">
          <h1 className="text-4xl font-bold text-primary mb-6">Contact Us</h1>

          {/* "Why Are You Reaching Out?" Section */}
          <div className="mb-6">
            <label
              htmlFor="reason-dropdown"
              className="block text-gray-700 font-medium mb-2"
            >
              Why are you reaching out? *
            </label>
            <select
              id="reason-dropdown"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
              value={selectedForm}
              onChange={(e) => setSelectedForm(e.target.value)}
            >
              {/* <option value="General Inquiry">General Inquiry</option> */}
              <option value="Machine Inquiry">Machine Inquiry</option>
              <option value="Print Job">Print Job</option>
              {/* <option value="Referral">Referral</option> */}
            </select>
          </div>

          {/* Dynamic Form Rendering */}
          {renderForm()}
        </div>
      </div>
    </div>
  );
};

export default Contact;
